(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2492],{

/***/ 49937:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[slug]",
      function () {
        return __webpack_require__(27602);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 54131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* reexport */ Loader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./lib/constants.js + 1 modules
var constants = __webpack_require__(99280);
;// CONCATENATED MODULE: ./components/atomic/Loader/Loader.tsx



var Loader = function(param) {
    var _message = param.message, message = _message === void 0 ? "Loading..." : _message;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "loader--search",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: "".concat(constants/* constants.imageHost.assets */._G.imageHost.assets, "/general/loading.gif"),
                alt: "loading",
                height: "75",
                width: "75",
                rel: "prefetch"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-2",
                children: message
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/atomic/Loader/index.ts



/***/ }),

/***/ 27602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var dayjs_plugin_advancedFormat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28734);
/* harmony import */ var dayjs_plugin_advancedFormat__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_advancedFormat__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _components_atomic_Loader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54131);
/* harmony import */ var _components_atomic_PageContainer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29099);
/* harmony import */ var _components_atomic_PageMetaData__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1429);
/* harmony import */ var _components_styleguide_Breadcrumbs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52488);
/* harmony import */ var _components_styleguide_ChatWidget__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(65299);
/* harmony import */ var _components_styleguide_Header__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(638);
/* harmony import */ var _components_views_SearchFormCTA__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85154);
/* harmony import */ var _lib_routes__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(7158);













var ContentPageBody = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8456), __webpack_require__.e(6310), __webpack_require__.e(6388), __webpack_require__.e(2705), __webpack_require__.e(9602)]).then(__webpack_require__.bind(__webpack_require__, 60250));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(60250)
            ];
        }
    }
});
var BlogArticlePage = function(param) {
    var article = param.article;
    dayjs__WEBPACK_IMPORTED_MODULE_1___default().extend((dayjs_plugin_advancedFormat__WEBPACK_IMPORTED_MODULE_2___default()));
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (typeof window.ttq !== "undefined") {
            window.ttq.track("ViewContent", {
                /* eslint-disable */ content_id: "".concat(article.content.title),
                content_type: "product",
                content_name: "".concat(article.content.title),
                /* eslint-enable */ quantity: 1,
                value: null,
                price: null,
                currency: "GBP"
            });
        }
    }, [
        article.content.title
    ]);
    if (!article) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "blog-page__content-loader",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atomic_Loader__WEBPACK_IMPORTED_MODULE_5__/* .Loader */ .a, {})
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atomic_PageMetaData__WEBPACK_IMPORTED_MODULE_7__/* .PageMetaData */ .S, {
                title: "".concat(article.content.title, " | LeaseLoco"),
                pageTitle: "".concat(article.content.title, " | LeaseLoco"),
                description: article.content.metaDescription ? article.content.metaDescription : article.content.description.replace(/<[^>]*>?/gm, ""),
                pageUrl: "/blog/".concat(article.urlKey),
                image: article.content.thumbnail,
                blogArticle: article.content
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styleguide_ChatWidget__WEBPACK_IMPORTED_MODULE_9__/* .ChatWidget */ .A, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styleguide_Header__WEBPACK_IMPORTED_MODULE_10__/* .Header */ .h, {
                backgroundColor: "white",
                backButtonUrl: _lib_routes__WEBPACK_IMPORTED_MODULE_12__/* .ROUTES.blogPage.url */ .Z.blogPage.url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_atomic_PageContainer__WEBPACK_IMPORTED_MODULE_6__/* .PageContainer */ ._, {
                containerClass: "container--blog-article",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styleguide_Breadcrumbs__WEBPACK_IMPORTED_MODULE_8__/* .Breadcrumbs */ .O, {
                        className: "content-breadcrumbs",
                        crumbs: [
                            {
                                label: "Home",
                                slug: _lib_routes__WEBPACK_IMPORTED_MODULE_12__/* .ROUTES.homePage.url */ .Z.homePage.url
                            },
                            {
                                label: "Leasing blog",
                                slug: _lib_routes__WEBPACK_IMPORTED_MODULE_12__/* .ROUTES.blogPage.url */ .Z.blogPage.url
                            },
                            {
                                label: article.content.title,
                                slug: null
                            }, 
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContentPageBody, {
                        article: article
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_views_SearchFormCTA__WEBPACK_IMPORTED_MODULE_11__/* .SearchFormCTA */ .g, {})
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (BlogArticlePage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2302,1852,5675,4660,8611,2580,638,1429,8515,9774,2888,179], function() { return __webpack_exec__(49937); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);